import { useMemo } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { BsCart3 } from 'react-icons/bs';
import { useNavigate, useParams } from 'react-router-dom';

import classNames from 'classnames';

import { BootstrapGenericTable } from '@components/Table/Table';
import { cartApi } from '@reducers/order';

const renderActionCell = ({ row }) => {
  const [trigger, result] = cartApi.useAddDidToCartMutation();
  const { id: planID, type, prefixID } = useParams();
  const data = { id: row.values.id, did: row.values.did };
  const { tos } = row.original;
  return (
    <Button
      variant="didxl"
      onClick={() => {
        trigger({ id: data.id, tos: tos.id, prefixID, planID, type });
      }}
      size="sm"
      disabled={result.isLoading}
    >
      <div>
        <BsCart3 size={17} /> Add
      </div>
    </Button>
  );
};

const renderBackorderButton = () => {
  const { id, type, prefixID } = useParams();
  const navigate = useNavigate();
  return (
    <Button
      variant="didxl"
      size="sm"
      onClick={() =>
        navigate(
          `/order/numbers/backorders/plans/${id}/type/${type}/prefixes/${prefixID}`
        )
      }
    >
      Place backorder
    </Button>
  );
};
const emptyTableContent = () => (
  <Row>
    <Col>
      <p className="m-0">
        There are no DIDs for this prefix or this Plan requires validated
        documents before we can allocate specific DID&rsquo;s.
      </p>
      <p>
        Please place a backorder in which you can specify the number of DIDs you
        require and the Profile for the order.
      </p>
    </Col>
  </Row>
);

export const SelectNumbersTable = ({ useData, useDataArgs }) => {
  const columns = useMemo(
    () => [
      {
        id: 'id',
        Header: '',
        accessor: 'id',
        className: 'hidden',
      },
      {
        Header: 'Number',
        accessor: 'did',
        className: 'col-md-4',
      },
      {
        id: 'lt',
        Header: 'LT',
        accessor: 'lt_available',
        className: classNames('col-md-1', 'text-center'),
      },
      {
        id: 'pstn',
        Header: 'PSTN',
        accessor: 'pstn_available',
        className: classNames('col-md-1', 'text-center'),
      },
      {
        id: 'sms',
        Header: 'SMS',
        accessor: 'sms_available',
        className: classNames('col-md-1', 'text-center'),
      },
      {
        Header: 'Plan',
        className: classNames('col-md-1', 'text-center'),
        accessor: 'plan.name',
      },
      {
        Header: 'Action',
        Cell: ({ row }) => renderActionCell({ row }),
        accessor: 'action',
        className: classNames('col-md-1', 'text-center'),
      },
    ],
    []
  );

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Available DIDs</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          useData={useData}
          useDataArgs={useDataArgs}
          columns={columns}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          hiddenColumns="id"
          paginated
          filterData={{}}
          emptyMessageContent={() => emptyTableContent()}
          exportContent={() => renderBackorderButton()}
        />
      </Card.Body>
    </Card>
  );
};
